import { Injectable } from '@angular/core';

@Injectable()
export class ApInputConstraintService {
    /**
     * Strip new value from disallowed characters.
     * If no pattern is passed the original value is returned
     */
    public strip(value: string, stripPattern?: RegExp): string {
        return stripPattern && typeof value === 'string' ? value.replace(stripPattern, '') : value;
    }
}
